module.exports = __webpack_public_path__ + "static/media/haxe.8b08228c.svg";